import styled from 'styled-components';

export const Container = styled.div`
  .textarea {
    resize: none;
    width: 100%;
    border-color: #ddd;
    border-radius: 4px;
    padding: 10px;
    font-size: 14px;
    outline: none;
    transition: 0.2s;
    &:hover {
      border-color: #939195;
    }

    &:focus {
      border-color: #1890ff;
    }
    &::placeholder {
      color: #aaa;
      font-size: 18px;
    }
  }
`;

export const ContButton = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  gap: 1rem;
`;

export const ListAttachments = styled.ul`
  list-style: none;
  padding-left: 0;

  .icon {
    font-size: 16px;
    padding: 5px;
    cursor: pointer;

    &:hover {
      background-color: #f0f0f0;
      border-radius: 4px;
    }
  }

  .showAttachments {
  }

  .deletAttachments {
  }

  .attachment {
  }
`;
